import Boss from "./Boss";

export default class BossDragon extends Boss {
    constructor() {
        super("adversary_dragon", Boss.TYPE_DRAGON);

        this.scale.set(0.5);

        this.setIdleAnims(["idle"]);
        this.setAttackAnims(["attack"]);
        this.setDamageAnims(["damage"]);
        this.setDefeatAnims(["defeat"]);
        this.setVictoryAnims(["victory"]);
        this.setEnterAnims(["enter"]);

        this._fireEmitter = null;
        this._fireEmitterBone = null;

        this._spine.state.addListener({
            event: (entry, event) => this.onAnimationEvent(entry, event)
        });

        this._attackSoundName = "sfx_dragon_attack_00";
        this._enterSoundName = "sfx_enter_dragon";
    }

    init() {
        super.init(P3.utils.selectRandom(["dragon1", "dragon2"]));

        const config = P3.assets.json("particle_emitter_dragon_flame");
        this._fireEmitter = new PIXI.particles.Emitter(this.parent, [P3.assets.texture("flame_particle_00")], config);
        this._fireEmitter.emit = false;

        this._fireEmitterBone = this._spine.skeleton.findBone("emitter_flame");
    }

    update(dt) {
        super.update(dt);

        this._fireEmitter.update(dt);

        const localPos = this._fireEmitter.parent.toLocal(new PIXI.Point(this._fireEmitterBone.worldX, this._fireEmitterBone.worldY), this._spine);
        this._fireEmitter.updateOwnerPos(localPos.x, localPos.y);
    }

    setEmitterParent(parent) {
        super.setEmitterParent(parent);

        this._fireEmitter.parent = parent;
    }

    onAnimationEvent(entry, event) {
        console.log(event);
        if (event.stringValue === "emitter_flame") {
            this._fireEmitter.emit = true;
        }
    }
}